<ng-template #header>
    <shared-vcard-for-order [orderId]="modalData.orderId" [showOrderId]="orderIsActive$ | async" [preTitle]="preTitle">
        {{title$ | async}}<ng-container *ngIf="locationName$ | async"><br />{{locationName$ | async}}</ng-container>
    </shared-vcard-for-order>
</ng-template>

<ng-template #footerEmpty>
    <shared-modal-item-actions [empty]="true">
    </shared-modal-item-actions>
</ng-template>

<ng-template #footer>
    <ng-template #left>

        <section class="footer__message">

            <ng-container
                *ngIf="!(isSendingEmailReceipt$ | async) && !(hasEmailSendingSucceeded$ | async) && !(hasEmailSendingFailed$ | async)">
                <shared-link [emphasis]="false" [disabled]="isSendingEmailReceipt$ | async"
                    (onClick)="handleEmailMyReceiptClick($event)" class="footer__text">Email my receipt
                </shared-link>
            </ng-container>

            <ng-container *ngIf="isSendingEmailReceipt$ | async">
                <div class="sending footer__flex">
                    <div class="sending__spinner"></div>
                    <div class="sending__text">Sending</div>
                </div>
            </ng-container>

            <ng-container *ngIf="hasEmailSendingSucceeded$ | async">
                <div class="success footer__flex">
                    <shared-icon [icon]="'checkmark'" class="success__icon"></shared-icon>
                    <span class="success__text">Email sent</span>
                </div>
            </ng-container>

            <ng-container *ngIf="hasEmailSendingFailed$ | async">
                <div class="footer__flex error">
                    <shared-icon [icon]="'x'" class="error__icon"></shared-icon>
                    <span class="error__text">
                        Issue sending email
                    </span>
                    <shared-link [emphasis]="false" [disabled]="isSendingEmailReceipt$ | async"
                        (onClick)="handleEmailMyReceiptClick($event)">Try again
                    </shared-link>
                </div>
            </ng-container>

        </section>



    </ng-template>

    <shared-two-columns class="modal-for-history-order__ft" [left]="left" [right]="null" align="left">
    </shared-two-columns>
</ng-template>

<shared-modal-type-dynamic-height (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
    [dimmedBg]="dimmedBg" [shadow]="shadow" [footer]="(isFinalized$ | async) === true ? footer : footerEmpty"
    [size]="size" [header]="header" [minHeight]="minHeight" [modalData]="modalData" [center]="true"
    [fullPaddings]="fullPaddings" (onCloseClick)="handleCloseClick($event)" class="modal-view-for-history-orders">

    <shared-order-full-summary [orderId]="modalData.orderId" [bottomPadding]="true"></shared-order-full-summary>

</shared-modal-type-dynamic-height>
